import {Component, OnInit} from "@angular/core";
import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";

import {AddNewShowroomDialogComponent} from "../add-new-showroom-dialog/add-new-showroom-dialog.component";
import {EditShowroomDialogComponent} from "../edit-showroom-dialog/edit-showroom-dialog.component";

import {AdminService, AlertService, CommonService} from "../../../_services/";
import {Subscription} from "rxjs";

@Component({
  selector: "app-showroom-list",
  templateUrl: "./showroom-list.component.html",
  styleUrls: ["./showroom-list.component.scss"],
})
export class ShowroomListComponent implements OnInit {
  showrooms: any;
  private subscription: Subscription;
  constructor(
    public dialog: MatDialog,
    private _common: CommonService,
    private _admin: AdminService,
    private _alert: AlertService
  ) {}

  ngOnInit() {
    this.getShowroomList();
    //  this.checkDriveAPI();
  }

  getShowroomList() {
    this._common.showLoader(true);
    this.subscription = this._admin.geShowroomList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.showrooms = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  openAddNewUserDialog() {
    let dialogRef = this.dialog.open(AddNewShowroomDialogComponent, {
      width: "auto",
    });

    dialogRef.afterClosed().subscribe((response) => {
      // this.getUserList(localStorage.getItem('uid'))
    });
  }

  openEditShowroomDialog(id) {
    let dialogRef = this.dialog.open(EditShowroomDialogComponent, {
      width: "auto",
      data: {id: id},
    });

    dialogRef.afterClosed().subscribe((response) => {
      // this.getUserList(localStorage.getItem('uid'))
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
